<template lang="pug">
  v-dialog.box-popup-alert(v-model="openPopup" persistent width="363" height="441")
    v-card(style="border-radius: 5px;")
      v-card-text
        v-layout(align-center justify-center column fill-height)
          v-flex(v-if="buttonClose" style="height: 0.5em;")
            v-btn(style="position: absolute;top: 5px;right: 5px;height: 2em;width: 2em;" @click="closeAlertPopup(false)" color="#0855C4" fab  flat)
              v-icon(style="line-height: initial;") close
          v-flex(style="margin-top: 1.5em;")
            v-img
              img(:src="image" style="width:150px;height:auto")
          v-flex(style="margin: .5em 1em;text-align: center;")
            span.omnesSemibold(style="font-size: 18px;color: #0855C4; line-height: 1.3;" v-html="title")
          v-flex(style="text-align: center;")
            span(style="font-size: 15px;line-height: initial;color: #535D66;" v-html="message")
          v-flex(style="margin-top: 1em;margin-bottom: 1em;")
            v-btn(v-if="linkButton" @click="closeAlertPopup()" style="background: #EA0D90;border-radius: 4px;height: 55px")
              span.omnesSemibold(style="text-transform: initial;font-size: 18px;color: #FFFFFF;") {{messageButton}}
            v-btn(v-else @click="closeAlertPopup()" style="background: #EA0D90;border-radius: 4px;width: 170px;height: 55px")
              span.omnesSemibold(style="text-transform: initial;font-size: 18px;color: #FFFFFF;") {{messageButton}}
</template>

<script>
export default {
  props: [
    'openPopup',
    'image',
    'title',
    'message',
    'messageButton',
    'linkButton',
    'buttonClose'
  ],
  data () {
    return {
    }
  },
  methods: {
    closeAlertPopup (item) {
      this.$emit('closeAlertPopup', item)
    },
    popupButton () {
      this.$router.push('/pago-de-cuotas')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/PopupSorteo.vue